import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { I18nModule } from '../../../../core/i18n';
import { LaunchDialogService } from '../../../../core/modal';
import { ModalModule } from '../../../../shared/components/modal';
import { emptyCartModalLayoutConfig } from './empty-cart-modal-layout.config';
import { EmptyCartModalComponent } from './empty-cart-modal.component';

@NgModule({
  imports: [CommonModule, ModalModule, I18nModule, KeyboardFocusModule],
  declarations: [EmptyCartModalComponent],
  exports: [EmptyCartModalComponent],
})
export class EmptyCartModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(emptyCartModalLayoutConfig);
  }
}
